module.exports = __webpack_public_path__ + "img/Number=85.48af6f83.png";